import React, { createContext, useContext, useEffect, useState } from "react";
import { decryptData } from "../../utils/crypto";
import CONFIG from "../../config";
import { getAllConfigList } from "../../services/commonServices";

const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [configData, setConfigDataList] = useState(null);
  const [loading, setLoading] = useState(true);

  const getCachedConfig = () => {
    try {
      const raw = localStorage.getItem(CONFIG.config_data);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      localStorage.removeItem(CONFIG.config_data);
      return null;
    }
  };

  useEffect(() => {
    const cached = getCachedConfig();
    if (cached) setConfigDataList(cached);

    getAllConfigList()
      .then((res) => {
        const decrypted = decryptData(res.data.data);
        const data = decrypted?.data;

        setConfigDataList(data);

        localStorage.setItem(
          CONFIG.config_data,
          JSON.stringify(data)
        );
      })
      .catch((err) => {
        console.log("Config load failed", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <ConfigContext.Provider value={{ configData, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};